
import { StationSupportContacts } from "@/api/dtos/Station.schema";
import { deepClone } from "@/misc/helpers";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";
import EditActionButtons from "../EditActionButtons.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
    EditActionButtons,
  },
})
export default class StationSupportContactsForm extends Vue {
  @Prop()
  stationSupportContacts!: StationSupportContacts;

  editedStationSupportContacts: StationSupportContacts | null = null;

  @Watch("stationSupportContacts")
  onStationSupportContactsChanged(): void {
    this.initializeWidget();
  }

  mounted(): void {
    this.initializeWidget();
  }

  initializeWidget(): void {
    this.editedStationSupportContacts = deepClone(this.stationSupportContacts);
  }

  $refs!: {
    editFrame: EditFrame;
  };
  isEditing = false;

  onSave(): void {
    this.$emit("save", this.editedStationSupportContacts);
  }

  onCancel(): void {
    this.editedStationSupportContacts = deepClone(this.stationSupportContacts);
  }
}
